import { defineMessages } from 'react-intl';

export default defineMessages({
  surveysList: 'Lista ankiet',
  name: 'Nazwa',
  choose: 'Wybierz',
});
